import { render, staticRenderFns } from "./HelpQuotesConfig.vue?vue&type=template&id=9063f584&"
import script from "./HelpQuotesConfig.vue?vue&type=script&lang=js&"
export * from "./HelpQuotesConfig.vue?vue&type=script&lang=js&"
import style0 from "./HelpQuotesConfig.vue?vue&type=style&index=0&id=9063f584&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports